export default "__VITE_ASSET__6c5cbeb5__"